'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Domain = undefined;

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _auroraJavascriptUtils = require('@unitedtraders/aurora-javascript-utils');

var _DomainBuilder = require('./DomainBuilder');

var _Cache = require('./cache/Cache');

var _Cache2 = _interopRequireDefault(_Cache);

var _RpcSystem = require('./rpc/RpcSystem');

var _urlUtils = require('./urlUtils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var logger = _auroraJavascriptUtils.log.getLogger('rpc');

function checkApplicationUrl(applicationUrl) {
    _auroraJavascriptUtils.assert.string(applicationUrl);

    if (!applicationUrl.endsWith('/')) {
        throw new Error('applicationUrl must ends with \'/\', but actual values is ' + applicationUrl);
    }

    return applicationUrl;
}

var defaultConfig = {
    contentLanguages: {
        list: ['en'],
        default: 'en'
    }
};

/**
 * contains information about all models and rpc for specific application
 */

var Domain = exports.Domain = function () {

    /**
     * @param options.applicationUrl - in example, "https://affiliate-test.auroraplatform.com/"
     * @param options.domainName - in example "luna-affiliate"
     * @param options.hateoasSuffix - optional override for "rest" part of url
     * @param options.superAgent - promisified version of superAgent
     * @param options.defineModels {function}
     * @param options.defineServices {function}
     * @param [options.Role] - enum with roles
     * @param [options.enums] - domain enums
     */
    function Domain(options) {
        _classCallCheck(this, Domain);

        var hateoasSuffix = options.hateoasSuffix || 'rest';

        this.applicationUrl = checkApplicationUrl(options.applicationUrl);
        this.baseUrl = this.applicationUrl + hateoasSuffix;
        this.domainName = _auroraJavascriptUtils.assert.string(options.domainName);
        this.models = {};
        this.builder = new _DomainBuilder.DomainBuilder(this);
        this.services = {};
        this._cache = new _Cache2.default();
        this.superAgent = _auroraJavascriptUtils.assert.object(options.superAgent);
        this.Role = _auroraJavascriptUtils.assert.func(options.Role);
        this.enums = _auroraJavascriptUtils.assert.object(options.enums);
        this.config = Object.assign({}, defaultConfig, options.config);

        this.createUrlBuilder = (0, _urlUtils.createUrlBuilder)(this.applicationUrl);
        this.rpcSystem = new _RpcSystem.RpcSystem(this);

        var defineModels = options.defineModels,
            defineServices = options.defineServices;

        defineModels(this.builder);
        defineServices(this.rpcSystem);

        this.builder.runDefineCallbacks();
    }

    _createClass(Domain, [{
        key: 'toString',
        value: function toString() {
            return 'Domain(\'' + this.domainName + '\')';
        }
    }, {
        key: '_idToLink',
        value: function _idToLink(id, hateoasType) {
            var result = this.baseUrl + '/' + hateoasType + '/' + id;
            if (!result.startsWith('http')) {
                var location = window.location;
                result = location.protocol + '//' + location.host + result;
            }

            return result;
        }
    }, {
        key: 'getCache',
        value: function getCache() {
            return this._cache;
        }
    }, {
        key: 'getModel',
        value: function getModel(modelName) {
            _auroraJavascriptUtils.assert.string(modelName);

            var model = this.models[modelName];

            if (!model) {
                throw new Error('can\'t find model \'' + modelName + '\' in domain \'' + this.domainName + '\'');
            }

            return model;
        }

        /**
         * @param serviceName {string}
         */

    }, {
        key: 'getService',
        value: function getService(serviceName) {
            _auroraJavascriptUtils.assert.string(serviceName);

            var service = this.services[serviceName];

            if (!service) {
                throw new Error('can\'t find service \'' + serviceName + '\' in domain \'' + this.domainName + '\'');
            }

            return service;
        }
    }, {
        key: 'getEnum',
        value: function getEnum(enumName) {
            _auroraJavascriptUtils.assert.string(enumName);

            var enumClass = this.enums[enumName];

            if (!enumClass) {
                throw new Error('can\'t find enum \'' + enumName + '\' in domain \'' + this.domainName + '\'');
            }

            return enumClass;
        }
    }, {
        key: 'getConfig',
        value: function getConfig(name, defaultValue) {
            if (this.config && typeof this.config[name] !== 'undefined') {
                return this.config[name];
            }
            return defaultValue;
        }
    }, {
        key: 'setupListeners',
        value: function setupListeners(app, name) {
            var _this = this;

            app.on('evictCache', function (payload) {
                var _payload$split = payload.split('.'),
                    _payload$split2 = _slicedToArray(_payload$split, 2),
                    domainName = _payload$split2[0],
                    modelName = _payload$split2[1];

                if (name !== domainName) {
                    return;
                }

                try {
                    var model = _this.getModel(modelName);
                    _this.getCache().invalidate(model);
                } catch (e) {
                    logger.warn('can\'t invalidate model ' + payload);
                }
            });
        }
    }]);

    return Domain;
}();


//////////////////
// WEBPACK FOOTER
// ./~/@unitedtraders/nested-hateoas/dist/Domain.js
// module id = 1408
// module chunks = 118